<table class="table table-bordered">
    <thead>
      <tr>
        <th scope="col">{{ 'annee_edition' | translate }}</th>
        <th scope="col">{{ 'nbr' | translate }}</th>
        <th scope="col">%</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let l of list">
        <td>{{ l.name }}</td>
        <td>{{ l.y }}</td>
        <td>{{ l.y*100/total | number : '1.2-2'  }} %</td>
      </tr>
      <tr>
        <th scope="row">{{ 'total' | translate }}</th>
        <th scope="row">{{ total }}</th>
        <th>{{ total*100/total | number  }} %</th>
      </tr>
    </tbody>
</table>